module.exports = __webpack_public_path__ + "static/img/Laura.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/christmasPC-2019/Laura.png
// module id = uh19
// module chunks = 1